import {
  Avatar,
  Badge,
  Button,
  Checkbox,
  Flex,
  Td,
  Text,
  Tr,
  useColorModeValue,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";

import { axiosPost } from "utils/api";
import EditLinkDialog from "components/Link/EditLinkDialog";
import { DeleteIcon, EditIcon } from "@chakra-ui/icons";
import AddBackupEmail from "components/SMTPServer/AddBackupEmail";
import SendEmailTestModal from "components/SMTPServer/SendEmailTestModal";
import { API_ROUTES } from "utils/constant";
import { IoIosSend } from "react-icons/io";
import { FaExchangeAlt } from "react-icons/fa";
import { HiSwitchHorizontal, HiSwitchVertical } from "react-icons/hi";
import { ROOT_API } from "utils/constant";

const deleteLinkApi =
  process.env.REACT_APP_API_HOST + process.env.REACT_APP_DELETE_URL;

function LinkRow(props) {
  const {
    smtpId,
    _id,
    logo,
    name,
    url,
    loop,
    order,
    status,
    timer,
    refetch,
    isLast,
    row,
    isSelected,
    onSelect,
  } = props;
  const textColor = useColorModeValue("gray.500", "white");
  const titleColor = useColorModeValue("gray.700", "white");
  const bgStatus = useColorModeValue("gray.400", "navy.900");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const [selectedEmail, setSelectedEmail] = useState();
  const {
    isOpen: isEditLinkOpen,
    onOpen: onEditLinkOpen,
    onClose: onEditLinkClose,
  } = useDisclosure();
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenSendMailModal,
    onOpen: onOpenSendMailModal,
    onClose: onCloseSendMailModal,
  } = useDisclosure();

  const closeSendMailModal = () => {
    setSelectedEmail(null);
    onCloseSendMailModal();
  };

  const handleDeleteEmail = async (e, _id) => {
    e.stopPropagation();
    if (window.confirm("Are you sure to remove this email")) {
      try {
        const dataDelete = {
          id: smtpId,
          backupId: _id,
        };
        const response = await axiosPost(
          ROOT_API + API_ROUTES.SMTP_SERVER_DELETE_BACKUP_EMAIL,
          dataDelete
        );
        if (response?.data?.code == 0) {
          toast({
            title: "Delete Email Backup Successfully",
            status: "success",
            duration: 9000,
            isClosable: true,
          });
          refetch();
        }
      } catch (error) {
        toast({
          title:
            error?.response?.data?.errors?.errors[0]?.msg ||
            error?.response?.data?.msg ||
            "Delete Email Backup Fail",
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    }
  };

  const handleEditEmailBackup = (email) => {
    onOpen();
    setSelectedEmail(email);
  };

  const handleChangeLimit = async (e, idEmail) => {
    e.stopPropagation();
    if (window.confirm("Are you sure to change the limit for this email")) {
      try {
        const dataPayload = {
          id: smtpId,
          smtpBackUpId: idEmail,
        };
        const response = await axiosPost(
          ROOT_API + API_ROUTES.CHANGE_LIMIT,
          dataPayload
        );
        if (response?.data?.code == 0) {
          toast({
            title: "Change limit email Backup Successfully",
            status: "success",
            duration: 9000,
            isClosable: true,
          });
          refetch();
        }
      } catch (error) {
        toast({
          title:
            error?.response?.data?.errors?.errors[0]?.msg ||
            error?.response?.data?.msg ||
            "Change limit email Backup Fail",
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    }
  };

  return (
    <>
      <Tr>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Checkbox isChecked={isSelected} onChange={() => onSelect(_id)} />
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Flex direction="column">
            <Text fontSize="md" color={textColor} fontWeight="bold">
              {name}
            </Text>
          </Flex>
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Flex direction="column">
            <Text fontSize="md" color={textColor} fontWeight="bold">
              {url}
            </Text>
          </Flex>
        </Td>

        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Flex direction="column">
            <Text fontSize="md" color={textColor} fontWeight="bold">
              {loop}
            </Text>
          </Flex>
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Flex direction="column">
            <Text fontSize="md" fontWeight="normal">
              {order}
            </Text>
          </Flex>
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Text fontSize="md" color={textColor} fontWeight="bold" pb=".5rem">
            {status ? "Yes" : "No"}
          </Text>
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Flex direction="column">
            <Text fontSize="md" fontWeight="bold">
              {row?.isBlocked ? "Blocked" : "Unblocked"}
            </Text>
          </Flex>
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Text fontSize="md" color={textColor} fontWeight="bold">
            {row?.createdByStore ? "Yes" : "No"}
          </Text>
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Flex alignItems={"center"}>
            <Button
              p="0px"
              bg="transparent"
              variant="no-effects"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedEmail(row);
                onOpenSendMailModal();
              }}
            >
              <IoIosSend size={16} />
            </Button>
            <Button
              p="0px"
              bg="transparent"
              variant="no-effects"
              onClick={() => handleEditEmailBackup(row)}
            >
              <EditIcon size={16} />
            </Button>
            <Button
              p="0px"
              bg="transparent"
              variant="no-effects"
              onClick={(e) => handleChangeLimit(e, _id)}
            >
              <HiSwitchHorizontal size={16} />
            </Button>
            <Button
              p="0px"
              // bg="red.400"
              variant="warning"
              onClick={(e) => handleDeleteEmail(e, _id)}
            >
              <DeleteIcon />
            </Button>
          </Flex>
        </Td>
        <EditLinkDialog
          isOpen={isEditLinkOpen}
          onOpen={onEditLinkOpen}
          onClose={onEditLinkClose}
          isAddLink={true}
          fetchData={() => refetch()}
          data={{ link: { _id, logo, name, url, loop, order, status, timer } }}
          isAdmin={true}
        />
      </Tr>
      <AddBackupEmail
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        fetchData={refetch}
        smtpId={smtpId}
        smtpSetting={selectedEmail}
      />
      {isOpenSendMailModal && (
        <SendEmailTestModal
          isOpen={isOpenSendMailModal}
          onOpen={onOpenSendMailModal}
          onClose={closeSendMailModal}
          fetchData={refetch}
          smtpId={smtpId}
          smtpBackUpId={selectedEmail?._id}
        />
      )}
    </>
  );
}

export default LinkRow;
